module.exports = __webpack_public_path__ + "img/3.5876ebf7.jpg";